<template>
  <div class="person">
    <!-- 使用Header组件 -->
    <LeftView ></LeftView>
    <div class="body">
      <router-view/>
    </div>
     
  </div>
</template>

<script>
import LeftView from "../components/LeftView"; 
export default { 
  components: {
    LeftView, 
  }
};
</script>

<style scoped>
 
.person{
  display: flex;
  flex-direction: row; 
  height: 100%;
  width: 100%;
  box-sizing: border-box;
} 
.body{
  flex: 1;
   margin-top: 100px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 12%;
  box-sizing: border-box;
}
</style>
